// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ContentButton_Wrapper___TwRN","Button":"ContentButton_Button__yaxi2"};